'use strict';

var self = module.exports = {

  init: function() {

    /************************************************************************************************************************
     * Inizializza la gallery
     /***********************************************************************************************************************/

    /**
     * Inizializza la gallery degli elementi draggabili
     *
     * @plugin
     */
    $('.gallery-draggable__carousel').owlCarousel({
      dots: false,
      lazyLoad: true,
      loop: true,
      mouseDrag: false,
      nav: true,
      navContainer: '.gallery-draggable__nav',
      navElement: 'div class="gallery-draggable__controls carousel__controls"',
      navText: false,
      responsive: {
        0: {
          items: 3
        },
        375: {
          items: 4
        },
        768: {
          items: 5
        },
        1024: {
          items: 7
        },
        1366: {
          items: 9
        },
        1680: {
          items: 11
        }
      },
      rewind: false,
      slideBy: 2,
      touchDrag: false
    });

    /************************************************************************************************************************
     * Inizializza il drag&drop di jQuery
     /***********************************************************************************************************************/

    /**
     * Inizializza il cavolo
     *
     */
    $('.draggable_theme_cabbage')
      .draggable({
        containment: '.canvas',
        cursor: 'move'
      })
      .addClass('draggable_deep_1')
      .find('.draggable__item')
      .data({
        'flipX': global.flipValueDefault,
        'flipY': global.flipValueDefault,
        'rotate': global.rotationValueDefault,
        'isCabbage': true
      });

    /**
     * Inizializza il draggable
     *
     * @plugin
     */
    $('.draggable_theme_all').draggable({
      appendTo: '.canvas',
      containment: 'window',
      cursor: 'move',
      helper: 'clone',
      revert: 'invalid',
      revertDuration: 200
    });

    /**
     * Inizializza il droppable
     *
     * @plugin
     */
    $('.canvas').droppable({
      accept: '.draggable_theme_all, .draggable_theme_cabbage',
      tolerance: 'fit',
      drop: function(event, ui) {

        /**
         * Recupera le dimensioni del canvas
         * per poter settare successivamente la posizione di ogni item in percentuale
         * e non in PX come di default
         */
        var $canvas = $('.canvas'),
          $canvasWidth = $canvas.width(),
          $canvasHeight = $canvas.height();

        /**
         * Recupera le seguenti informazioni dell'elemento droppato:
         * - flip sull'asse X
         * - flip sull'asse Y
         * - rotazione
         *
         * Se non le trova le setta con i valori di default
         */
        var $flipX = ui.helper.find('.draggable__item').data('flipX'),
          $flipY = ui.helper.find('.draggable__item').data('flipY'),
          $isCabbage = ui.helper.find('.draggable__item').data('isCabbage'),
          $rotate = ui.helper.find('.draggable__item').data('rotate');

        if($flipX == undefined) {
          $flipX = global.flipValueDefault;
        }

        if($flipY == undefined) {
          $flipY = global.flipValueDefault;
        }

        if($isCabbage == undefined) {
          $isCabbage = global.isCabbageValueDefault;
        }

        if($rotate == undefined) {
          $rotate = global.rotationValueDefault;
        }

        $(document)
          .find('.editor__canvas')
          .attr('data-modified', 1);

        /**
         * Clona l'elemento draggato e setta i seguenti parametri:
         * - flip sull'asse X
         * - flip sull'asse Y
         * - posizione sull'asse Y del canvas
         * - posizione sull'asse X del canvas
         * - rotazione
         */
        ui.helper
          .clone()
          .insertAfter(ui.helper)
          .draggable({
            containment: '.canvas'
          })
          .addClass('draggable_deep_1')
          .css({
            top: (100 * ui.position.top / $canvasHeight) + '%',
            left: (100 * ui.position.left / $canvasWidth) + '%'
          })
          .find('.draggable__item')
          .data({
            'flipX': $flipX,
            'flipY': $flipY,
            'isCabbage': $isCabbage,
            'position-top': (100 * ui.position.top / $canvasHeight) + '%',
            'position-left': (100 * ui.position.left / $canvasWidth) + '%',
            'rotate': $rotate
          });

        /**
         * Rimuove la copia dell'elemento clonato
         * per evitare la duplicazione ripetitiva
         */
        ui.helper.remove();

        /**
         * Mostra le opzioni e seleziona l'elemento
         * se l'elemento droppato è il primo
         * altrimenti nasconde le opzioni se queste sono aperte
         */
        if($canvas.find('.draggable_theme_all').length == 1) {

          if($canvas.find('.draggable_theme_all').attr('id') == undefined) {
            $canvas.find('.draggable_theme_all').attr('id', Date.now());
            modifiers.selected($('.canvas').find('.draggable_theme_all'));
            canvas.open($('.canvas__footer'));
          }
        } else {
          $('.canvas')
            .find('.draggable')
            .removeClass('draggable_selected');

          canvas.close($('.canvas__footer'));
        }

        /**
         * Verifico che la gallery colori di sfondo sia aperta
         * se la condizione è vera chiudo le opzioni
         */
        if($('.canvas__options').hasClass('open')) {
          canvas.close($('.canvas__options'), $('[data-js="canvas-options"]'));
        }
      }
    });

    /************************************************************************************************************************
     * Salvataggio
     /***********************************************************************************************************************/

    $('[data-js="editor-save"]').click(function() {
      if($( this ).context.id == 'salva'){
        console.log('Salva');
        dataLayer.push({
          event: 'click',
          context_submitted:'salva'
        })
      }
      var $canvas = $('.canvas'),
        $canvasColor = $canvas.css('background-color'),
        $canvasWidth = $canvas.width(),
        $canvasHeight = $canvas.height(),
        $items = $canvas.find('.draggable__item'),
        $itemsList = {},
        $itemsLength = $items.length,
        $isModified = $(document).find('.editor__canvas').attr('data-modified'),
        $parent = $(document).find('.editor__canvas').attr('data-parent'),
        $positionTop,
        $positionLeft,
        $titleArtwork = $('.artwork-title__form-input').val();

      global.thumb.attr('src', 'assets/images/loading/loading-gear-green.gif');

      /**
       * Crea un oggetto js con all'interno tutti gli elementi presenti nel canvas
       * con le seguenti proprietà:
       * - tipo di item
       * - indice di profondità dei livelli
       * - flip sull'asse X
       * - flip sull'asse Y
       * - tipo di elemento (se cavolo)
       * - posizione in % sull'asse Y del canvas
       * - posizione in % sull'asse X del canvas
       * - rotazione
       * - larghezza originale
       * - altezza originale
       */
      $items.each(function(index, element) {
        $(element).data('index', index);

        /**
         * Verifico se la position TOP dell'elemento è già un numero
         */
        if(isNaN($(element).data('positionTop'))) {
          $positionTop = $(element).data('positionTop');
        } else {
          $positionTop = Math.round(100 * $(element).data('positionTop') / $canvasHeight) + '%';
        }

        /**
         * Verifico se la position LEFT dell'elemento è già un numero
         */
        if(isNaN($(element).data('positionLeft'))) {
          $positionLeft = $(element).data('positionLeft');
        } else {
          $positionLeft = Math.round(100 * $(element).data('positionLeft') / $canvasWidth) + '%';
        }

        $itemsList[index] = {
          item: $(element).parent('.draggable').data('tag'),
          index: $(element).data('index'),
          flipX: $(element).data('flipX'),
          flipY: $(element).data('flipY'),
          isCabbage: $(element).data('isCabbage'),
          positionTop: $positionTop,
          positionLeft: $positionLeft,
          rotate: $(element).data('rotate'),
          originalWidth: $(element).attr('data-original-width'),
          originalHeight: $(element).attr('data-original-height')
        };

        if (!--$itemsLength) {
          /**
           * Variabili da registrare nel DB
           */
          // console.log(JSON.stringify($itemsList));
          // console.log($isModified);
          // console.log($canvasColor);
          // console.log($itemsList);

          $.post('/artwork-save', {
            data: JSON.stringify($itemsList),
            parent: $parent,
            isModified: $isModified,
            artworkId: global.artworkId,
            background: $canvasColor
          }, function(output) {
            if (output.error) {
              console.log('Ops! Qualcosa è andato storto!');
            } else {
              global.artworkId = output.id
              global.updateThumb(output.id);
            }
            // console.log(output);
          });
        }
      });

      /**
       * Stampo il titolo dell'opera nel campo del form
       */
      $('.preview__artwork-title').val($titleArtwork);

      /**
       * Dopo il salvataggio si passa alla sezione successiva
       */
      $.fn.fullpage.moveSectionDown();

    });
  }
}

self.init();

